window.Vue = require('vue');

//Global
Vue.component('topbar-unread-messages-counter', require('./topbar/unreadMessagesCount.vue'));

Vue.use
//Topbar
//Vue.component('topbar-unread-messages-counter', require('./topbar/unreadMessagesCount.vue'));
// Vue.component('topbar-unread-notifications-counter', require('./topbar/unreadNotificationsCount.vue'));
// Vue.component('topbar-unread-notifications-dropdown', require('./topbar/unreadNotifications.vue'));
Vue.component('topbar-unread-topics-dropdown', require('./topbar/unreadTopics.vue'));

//Sidebar
Vue.component('sidebar-unread-messages-counter', require('./sidebar/unreadMessagesCount.vue'));
Vue.component('sidebar-unread-notifications-counter', require('./sidebar/unreadNotificationsCount.vue'));
Vue.component('sidebar-unread-events-counter', require('./sidebar/unreadEventsCount.vue'));

//Messenger
Vue.component('make-messages-as-read', require('./admin/messenger/makeMessagesAsRead.vue'));

//Notifications
Vue.component('make-notification-as-read', require('./admin/notifications/makeNotificationAsRead.vue'));

//Widgets
//Vue.component('latest-notifications', require('./widgets/latestNotifications.vue'));

//Discussion
Vue.component('model-discussion', require('./admin//discussion/modelDiscussion.vue'));

//Visit Counter Widget
Vue.component('visit-counter-widget', require('./widgets/VisitCounterWidget/VisitCounterWidget.vue'));

//Daily Views Widget
Vue.component('daily-traffic-widget', require('./widgets/DailyTraffic/DailyTrafficWidget.vue'));


//Visit Counter Widget
Vue.component('visit-graph-widget', require('./widgets/VisitGraphWidget/VisitGraphWidget.vue'));

Vue.component('traffic-log-country-report', require('./admin/traffic-log-country-report/TrafficLogCountryReport.vue'));

Vue.component('traffic-code-log-report', require('./admin/traffic-code-log-report/TrafficCodeLogReport.vue'));

Vue.component('traffic-log-owned-website-report', require('./admin/traffic-log-owned-website-report/TrafficLogOwnedWebsiteReport.vue'));

Vue.component('create-traffic-owner-report', require('./admin/traffic-log-owner-report/CreateTrafficOwnerReport.vue'));

Vue.component('server-to-server-traffic-settings', require('./admin/traffic-settings/ServerToServerTrafficSettings.vue'));

Vue.component('target-inputs', require('./admin/mass-target-management/TargetInputs'));

Vue.component('insight', require('./widgets/InsightWidget/InsightWidget.vue'))

Vue.component('traffic-code-log-country-report', require('./admin/traffic-code-log-country-report/TrafficCodeLogCountryReport.vue'));

Vue.component('daily-traffic-widget', require('./widgets/DailyTraffic/DailyTrafficWidget.vue'));

Vue.component('traffic-price', require('./admin/traffic-log-owner-report/TrafficPrice.vue'));






// WEBPACK FOOTER //
// ./resources/js/admin-panel/components/vue-declarator.js